module.exports = __webpack_public_path__ + "img/student_22.509d8816.png";